<template>
  <div class="content-8__content">
    <div class="table-scroll">
      <table>
        <thead>
          <tr>
            <th>期数</th>
            <th colspan="6">正码1</th>
            <th colspan="6">正码2</th>
            <th colspan="6">正码3</th>
            <th colspan="6">正码4</th>
            <th colspan="6">正码5</th>
            <th colspan="6">正码6</th>
          </tr>
        </thead>

        <tbody>
          <template v-for="(period, periodIndex) in tableData">
            <tr v-if="periodIndex < extendConut" :key="`${periodIndex}-tableData`">
              <!-- 期数 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text">{{ period.period }}期</span>
                </div>
              </td>
              <template v-for="(item, index) in 6">
                <!-- 號碼 -->
                <td :key="`1-${index}`">
                  <div class="tableballbox">
                    <div class="tableballbox__item">
                      <div
                        class="ball circle size-middle"
                        :class="getSebo(periodIndex,index)"
                      >
                        <span class="ball__number">{{ padZero(period.balls[index]) }}</span>
                      </div>
                    </div>
                  </div>
                </td>
                <!-- 大小 -->
                <td :key="`2-${index}`">
                  <div class="tableballbox">
                    <span class="textbox__text" :class=" textColor(period.hmDaXiao[index])">{{ ruleCodeMapping[period.hmDaXiao[index]] }}</span>
                  </div>
                </td>
                <!-- 单双 -->
                <td :key="`3-${index}`">
                  <div class="tableballbox">
                    <span class="textbox__text" :class=" textColor(period.hmDanShuang[index])">{{ ruleCodeMapping[period.hmDanShuang[index]] }}</span>
                  </div>
                </td>
                <!-- 合大小 -->
                <td :key="`4-${index}`">
                  <div class="tableballbox">
                    <span class="textbox__text" :class=" textColor(period.hmHeDaXiao[index])">合<br>{{ ruleCodeMapping[period.hmHeDaXiao[index]] }}</span>
                  </div>
                </td>
                <!-- 合单双 -->
                <td :key="`5-${index}`">
                  <div class="tableballbox">
                    <span class="textbox__text" :class=" textColor(period.hmHeDanShuang[index])">合<br>{{ ruleCodeMapping[period.hmHeDanShuang[index]] }}</span>
                  </div>
                </td>
                <!-- 尾大小 -->
                <td :key="`6-${index}`">
                  <div class="tableballbox">
                    <span class="textbox__text" :class=" textColor(period.hmWeiShuDaXiao[index])">
                      尾<br>{{ ruleCodeMapping[period.hmWeiShuDaXiao[index]] }}
                    </span>
                  </div>
                </td>

              </template>

            </tr>
          </template>
          <tr v-if="!noMore">
            <td colspan="40">
              <span class="button-primary c8-datebox__item active" @click="loadList">显示更多</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { ruleCodeMapping } from '@/utils/newRuleCodeMapping-Sean'
import moment from 'moment'

export default {
  name: 'ZhengMaFenXi',
  props: {
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      extendConut: 30,
      selectFilterProperty: '',
      ruleCodeMapping: ruleCodeMapping
    }
  },
  computed: {
    noMore() {
      return this.extendConut >= this.tableData.length
    },
    isHK() {
      return this.$route.params.lottery_code === 'hk6'
    }
  },
  methods: {
    // 轉換utc時間格式
    formatDrawTime(time) {
      return this.isHK ? moment(time).format('YYYY/MM/DD') : moment(time).format('HH:mm')
    },
    // 拿顏色
    getSebo(periodIndex, ballIndex) {
      switch (this.tableData[periodIndex].seBo[ballIndex]) {
        case 'yanse_hong':
          return 'color--red'
        case 'yanse_lan':
          return 'color--blue'
        case 'yanse_lyu':
          return 'color--green'
        default:
          return ''
      }
    },
    // 取個位數
    getUnits(number) {
      return parseInt(number % 10)
    },
    textColor(value) {
      switch (value) {
        case 'daxiao_da':
        case 'danshuang_shuang':
        case 'yanse_hong':
          return 'red'
        case 'yanse_lan':
        case 'daxiao_he':
        case 'danshuang_he':
          return 'blue'
        case 'yanse_lyu':
          return 'green'
        default:
          return ''
      }
    },
    // 一次性載入的數量
    loadList() {
      this.extendConut += 30
    },
    padZero(num) {
      return String(num).padStart(2, '0')
    }
  }
}
</script>

<style lang="scss" scoped>
  .c8-datebox__item {
    &:hover {
      cursor: pointer;
    }
  }
</style>

